import { Space } from '@billy/design-system'
import { ReactElement } from 'react'

import { Scope } from '../../../../../../enums/scope'
import { isAuthorized } from '../../../../../../utils/isAuthorized'
import { VatDeclarationsCorrectionBanner } from '../../../VatDeclarationsCorrectionBanner'
import { FoundSuggestionsBanner } from '../../../VatSuggestions/elements/FoundSuggestionsBanner'
import { VatSuggestionsSource } from '../../../VatSuggestions/enums/vatSuggestionsSource'
import { SkatNotAvailableMessage } from '../SkatNotAvailableMessage'

interface InfoSectionProps {
  isSkatAvailable: boolean
  isValidCVR: boolean
  shouldShowCorrectionBanner: boolean
}

export const InfoSection = ({
  isSkatAvailable,
  isValidCVR,
  shouldShowCorrectionBanner,
}: InfoSectionProps): ReactElement | null => {
  const hasUpsellScope = isAuthorized(Scope.VatHelperUpsell)
  const hasWriteScope = isAuthorized(Scope.VatHelperWrite)
  const isCopilotAvailable = hasUpsellScope || hasWriteScope
  const shouldShowAddSVR = isSkatAvailable && !isValidCVR

  if (!shouldShowCorrectionBanner && !shouldShowAddSVR && !isCopilotAvailable) {
    return null
  }

  return (
    <>
      {shouldShowCorrectionBanner && (
        <>
          <VatDeclarationsCorrectionBanner />
          <Space size="s24" />
        </>
      )}
      {shouldShowAddSVR && (
        <>
          <SkatNotAvailableMessage />
          <Space />
        </>
      )}
      {isCopilotAvailable && <FoundSuggestionsBanner source={VatSuggestionsSource.FrontPage} />}
    </>
  )
}
